module.exports = __webpack_public_path__ + "static/media/light-06.cf8a0878.jpg";